import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../assets/scss/Lesson.scss";

const VideoLesson = ({ videoUrl, lessonTitle }) => {
	const navigate = useNavigate();
	const { subjectSlug, courseSlug, unitSlug, lessonSlug, lessonId } =
		useParams();

	const handleQuizNavigation = () => {
		if (!lessonTitle) return;

		navigate(
			`/courses/${subjectSlug}/${courseSlug}/${unitSlug}/${lessonSlug}/${lessonId}/quiz`
		);
	};

	const getEmbedUrl = (url) => {
		if (!url) return "";
		const videoId = url.match(
			/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/watch\?.+&v=))([\w-]{11})/
		);

		return videoId ? `https://www.youtube.com/embed/${videoId[1]}` : "";
	};

	return (
		<div className="video-lesson">
			<h1 className="video-lesson__title">{lessonTitle}</h1>
			<div className="video-lesson__content">
				<div className="video-lesson__player">
					{videoUrl ? (
						<iframe
							width="945"
							height="543"
							src={getEmbedUrl(videoUrl)}
							title={lessonTitle}
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen></iframe>
					) : (
						<div>Video not available.</div>
					)}
				</div>
				<div className="video-lesson__actions">
					<button
						className="video-lesson__quiz-btn"
						onClick={handleQuizNavigation}>
						Take Quiz
					</button>
				</div>
			</div>
		</div>
	);
};

export default VideoLesson;
